import { func } from 'prop-types';
import React from 'react';
import { MediaManagerSDKAnyItem } from '../../../utils/media-manager-sdk';
import { IRectangle, IRectangleVertex } from '../../../utils/rectangles/rectangles.types';
import { contextTypes as withLassoSelectedAreaContextTypes } from './withLassoSelectedAreaStyle/withLassoSelectedAreaStyle.types';

export interface ILassoContext {
  onLassoItemReady: (itemId: string, element: HTMLElement) => void;
  onLassoItemDestroy: (itemId: string) => void;
}

export interface ILassoItems {
  [itemId: string]: HTMLElement;
}

export interface IOuter {
  itemMarginRight: number;
  selectedItems: MediaManagerSDKAnyItem[];
  onSelectStart?: () => void;
  onFirstMove?: () => void;
  onSelectItems: (selectedIds: string[]) => void;
  onSelectFinish?: (selectedIds: string[]) => void;
  children: React.ReactNode;
}

export interface IInner extends IOuter {
  lassoItems: ILassoItems;
  selectedAreaStyle: Partial<React.CSSProperties>;
  saveScrollingComponentWrapperRef: (el: React.Component) => void;
  saveRef(node: HTMLElement): void;
  handleLassoStart(event: React.MouseEvent<HTMLDivElement>): void;
}

export type TLassoRectangleVertex = IRectangleVertex;
export type TLassoRectangle = IRectangle;

export const contextTypes = {
  ...withLassoSelectedAreaContextTypes,
  onLassoItemReady: func,
  onLassoItemDestroy: func,
};

export interface IState {
  lassoItems: ILassoItems;
  selectedArea: TLassoRectangle;
  hasFirstMoveDone: boolean;
}

export type TStateUpdaters = {
  onLassoItemReady: (itemId: string, element: HTMLElement) => Partial<IState>;
  onLassoItemDestroy: (itemId: string) => Partial<IState>;
  setSelectedArea: (selectedArea: TLassoRectangle) => Partial<IState>;
  setFirstMoveDone: (value: boolean) => Partial<IState>;
};

export interface ILassoRectangleItems {
  [itemId: string]: TLassoRectangle;
}

export type TRectanglePair = [string, TLassoRectangle];

export interface IHandlers {}

export enum AutoScrollDirection {
  Bottom = 'bottom',
  Top = 'top',
}
